import keyBy from 'lodash/keyBy';
import pick from 'lodash/pick';
import {
  REGISTER_FETCH_SUMMARY,
  REGISTER_FETCH_SUMMARY_START,
  REGISTER_REFUND_CUSTOM_CHARGE,
  REGISTER_REFUND_SALE,
  REGISTER_REASSIGN_SALE,
  REGISTER_REFUND_RECURRING_MEMBERSHIP,
} from '../constants';
import { CAPTURE_REFUND } from '../../../terminal/constants';

const refundList = (state = {}, action) => {
  switch (action.type) {
    case CAPTURE_REFUND:
    case REGISTER_FETCH_SUMMARY_START:
      return {};
    case REGISTER_FETCH_SUMMARY:
      return {
        ...state,
        ...keyBy(action.payload.transactions, 'id'),
      };
    case REGISTER_REFUND_SALE: {
      const sale = { ...state[action.payload.saleId] };
      sale.items = sale.items.map((item) => {
        if (item.id !== action.payload.id) return item;

        return ({
          ...item,
          chargeRefundId: action.payload.chargeRefundId,
        });
      });

      return {
        ...state,
        [sale.id]: sale,
      };
    }
    case REGISTER_REFUND_CUSTOM_CHARGE: {
      const charge = {
        ...state[action.payload.id],
        chargeRefundId: action.payload.transaction.chargeRefundId,
      };

      return {
        ...state,
        [charge.id]: charge,
      };
    }

    case REGISTER_REASSIGN_SALE: {
      const { barber, parentId, id } = action.payload;
      const charge = { ...state[parentId] };

      charge.items = charge.items.map((item) => {
        if (item.id !== id) return item;

        return ({
          ...item,
          barber: {
            ...pick(barber, ['id', 'firstName', 'lastName']),
            name: `${barber.lastName} ${barber.lastName}`,
          },
        });
      });

      return ({
        ...state,
        [charge.id]: charge,
      });
    }

    case REGISTER_REFUND_RECURRING_MEMBERSHIP: {
      const item = {
        ...state[action.payload.id],
        refundable: false,
      };

      return {
        ...state,
        [item.id]: item,
      };
    }

    default:
      return state;
  }
};

export default refundList;
